import React, { useState } from 'react';
import { Button, Divider, IconButton, Menu } from 'react-native-paper';
import { MaterialIcons } from '@expo/vector-icons';
import { useNavigation } from '@react-navigation/native';

import { SCREEN_NAMES } from '../routes';
import { useAuth, useThemeContext } from '../../contexts';

export type AccountMenuProps = {
  iconColor?: string;
  displayMobileMenu: boolean;
  onSignOut: () => void;
}

export const AccountMenu = (props: AccountMenuProps) => {
  const { iconColor, displayMobileMenu, onSignOut } = props;
  const { theme } = useThemeContext();
  const { session } = useAuth();
  const navigation = useNavigation();

  const guestCheckout = session?.appConfig.guestCheckoutEnabled;

  const [isAccountMenuOpen, setAccountMenuOpen] = useState(false);

  const navigateToScreen = (screen: string) => {
    // @ts-ignore
    navigation.navigate(screen);
    setAccountMenuOpen(false);
  };

  return (
    <>
      <Menu
        visible={isAccountMenuOpen}
        onDismiss={() => setAccountMenuOpen(false)}
        anchorPosition={'bottom'}
        anchor={
          displayMobileMenu ? (
            <IconButton icon={'account-circle'} iconColor={iconColor || theme.colors.primary} onPress={() => setAccountMenuOpen(true)} />
          ) : (
            <Button
              mode={'text'}
              compact
              labelStyle={{ fontSize: 15, fontWeight: 'bold', color: iconColor || theme.colors.primary }}
              icon={() => <MaterialIcons name={'account-circle'} size={24} color={iconColor || theme.colors.primary} />}
              onPress={() => setAccountMenuOpen(true)}
            >
              My Account
            </Button>
          )
        }
      >
        {!guestCheckout && (
          <>
            <Menu.Item leadingIcon={'account-circle'} title={'My Profile'} onPress={() => navigateToScreen(SCREEN_NAMES.PROFILE)} />
            <Menu.Item leadingIcon={'history'} title={'Order History'} onPress={() => navigateToScreen(SCREEN_NAMES.ORDER_HISTORY)} />
            <Divider />
          </>
        )}
        <Menu.Item leadingIcon={'exit-to-app'} title={'Sign Out'} onPress={onSignOut} />
      </Menu>
    </>
  );
}
